import { validateInput } from "./BusinessBillValidationService";
import { isFullFormValid } from "../../util/Validators";
import { validate } from "uuid";

export const businessAccountBillValidationInitialState = {
  billTypeError: false,
  billTypeErrMsg: "",
  amountDueError: false,
  amountDueErrMsg: "",
  dueDateError: false,
  dueDateErrMsg: "",
  billDateError: false,
  billDateErrMsg: "",
  accountIdError: false,
  accountIdErrMsg: "",
  billIdError: false,
  billIdErrMsg: "",
  lineItemsError: false,
  lineItemsErrMsg: "",

  isFormValid: true
}

export const BusinessAccountBillFormValidationReducer = (state, action) => {
  if (!action.payload) {
    return state;
  }
  let isValid = false;
  let actionType = action.type;
  let amountMatch = actionType.match('VALIDATE_AMOUNT_\\d+$');
  let descriptionMatch = actionType.match('VALIDATE_DESCRIPTION_\\d+$');
  let quantityMatch = actionType.match('VALIDATE_QUANTITY_\\d+$');

  let prefix = '';
  let key = '';
  let fieldError = ``;
  let fieldErrorMessg = ``;

  switch (action.type) {
    case (amountMatch !== null && amountMatch.length > 0 && amountMatch[0]):
      let amountObj = action.payload;
      prefix = 'VALIDATE_AMOUNT_';
      key = actionType.substring(prefix.length, actionType.length);

      let amountState = validateInput('amount', Object.entries(amountObj)[0][1]);
      isValid = !amountState.hasError;
      let amountErrMsg = amountState.error;
      fieldError = `amount_${key}Error`;
      fieldErrorMessg = `amount_${key}ErrMsg`;
      return {
        ...state,
        ...({ [fieldError]: !isValid, [fieldErrorMessg]: amountErrMsg, isFormValid: isFullFormValid(state, [fieldError], !isValid) })
      }
    case (descriptionMatch !== null && descriptionMatch.length > 0 && descriptionMatch[0]):
      let descriptionObj = action.payload;
      prefix = 'VALIDATE_DESCRIPTION_';
      key = actionType.substring(prefix.length, actionType.length);

      let descriptionState = validateInput('description', Object.entries(descriptionObj)[0][1]);
      isValid = !descriptionState.hasError;
      let descriptionErrMsg = descriptionState.error;

      fieldError = `description_${key}Error`
      fieldErrorMessg = `description_${key}ErrMsg`
      return {
        ...state,
        ...({ [fieldError]: !isValid, [fieldErrorMessg]: descriptionErrMsg, isFormValid: isFullFormValid(state, [fieldError], !isValid) })
      }

    case (quantityMatch !== null && quantityMatch.length > 0 && quantityMatch[0]):
      let quantityObj = action.payload;
      prefix = 'VALIDATE_QUANTITY_';
      key = actionType.substring(prefix.length, actionType.length);

      let quantityState = validateInput('quantity', Object.entries(quantityObj)[0][1]);
      isValid = !quantityState.hasError;
      let quantityErrMsg = quantityState.error;

      fieldError = `quantity_${key}Error`
      fieldErrorMessg = `quantity_${key}ErrMsg`
      return {
        ...state,
        ...({ [fieldError]: !isValid, [fieldErrorMessg]: quantityErrMsg, isFormValid: isFullFormValid(state, [fieldError], !isValid) })
      }
    case "VALIDATE_AMOUNTDUE":
      let { amountDue } = action.payload;
      let amountDueState = validateInput('amountDue', amountDue);
      isValid = !amountDueState.hasError;

      let amountDueErrMsg = amountDueState.error;
      return {
        ...state,
        ...({ amountDueError: !isValid, amountDueErrMsg: amountDueErrMsg, isFormValid: isFullFormValid(state, 'amountDueError', !isValid) })
      }
    case "VALIDATE_DUEDATE":
      let { dueDate } = action.payload;
      let dueDateState = validateInput('dueDate', dueDate);
      isValid = !dueDateState.hasError;
      let dueDateErrMsg = dueDateState.error;

      return {
        ...state,
        ...({ dueDateError: !isValid, dueDateErrMsg: dueDateErrMsg, isFormValid: isFullFormValid(state, 'dueDateError', !isValid) })
      }
    case "VALIDATE_BILLDATE":
      let { billDate } = action.payload;
      let billDateState = validateInput('billDate', billDate);
      isValid = !billDateState.hasError;
      let billDateErrMsg = billDateState.error;
      return {
        ...state,
        ...({ billDateError: !isValid, billDateErrMsg: billDateErrMsg, isFormValid: isFullFormValid(state, 'billDateError', !isValid) })
      }

    case "VALIDATE_ACCOUNTID":
      let { accountId } = action.payload;
      let accountIdState = validateInput('accountId', accountId);
      isValid = !accountIdState.hasError;
      let accountIdErrMsg = accountIdState.error;
      return {
        ...state,
        ...({ accountIdError: !isValid, accountIdErrMsg: accountIdErrMsg, isFormValid: isFullFormValid(state, 'accountIdError', !isValid) })
      }

    case "VALIDATE_LINEITEMS":
      let { lineItems } = action.payload;
      let lineItemsState = validateInput('lineItems', lineItems);
      isValid = !lineItemsState.hasError;
      let lineItemsErrMsg = lineItemsState.error;
      return {
        ...state,
        ...({ lineItemsError: !isValid, lineItemsErrMsg: lineItemsErrMsg, isFormValid: isFullFormValid(state, 'lineItemsError', !isValid) })
      }
    case "VALIDATE_KEYWORD":
      let {keyword} = action.payload;
      let keywordValState = validateInput('keyword', keyword); 
      isValid = !keywordValState.hasError;
      let keywordErrMsg = keywordValState.error;
      return {
        ...state,
        ...({ keywordError: !isValid, keywordErrMsg: keywordErrMsg, isFormValid: isFullFormValid(state, 'keywordError', !isValid) })
      } 

    default:
      return state
  }
}



